<!-- <mat-sidenav-container
class="template-drawer-container flex-auto h-screen overflow-y-hidden z-[1200]"
fullscreen
[style.position]="sidenav.opened ? 'fixed' : 'relative'"
>
<mat-sidenav
  #sidenav
  mode="over"
  position="end"
  style="overflow: hidden; overflow-y: scroll; min-width: 100px !important; visibility: visible !important"
  class="sidenav container_nav"
  [fixedInViewport]="true"
  [fixedTopGap]="0"
  (openedChange)="handleNav($event)"
  > -->
  <header
    class="account__setup--header relative"
      [ngClass]="{
        'mt-0': !switchFromUser, 
        'mt-3': switchFromUser
      }"
    >
    <p class="font-open-sans font-medium text-[16px] leading-6">Select Template </p>
    <span class="material-icons relative bg-white text-[#898F9E] text-2xl cursor-pointer" (click)="closeSideNav()" >clear</span>
  </header>

  <section class="app__discovery_section--content">
    <ng-container>
      <div class="nav w-[300px]">
        <nav class="w-full h-full">
          
            @if (from == 'section' || from == 'vault') {
              <ul class="w-full h-full overflow-y-scroll scroll-container"  [ngClass]="{'overflow-register-templateclass': switchFromUser}">
                @for (step of steps; track step; let i = $index) {
                  <li
                    class="app__stepper__config-stepitem"
                    (click)="getTemplate(step.name)"
                [ngClass]="{
                  'app__stepper__config-stepitem-selected': step.name == organization_group
                }"
                    >
                    @if (step.percent_complete == '100') {
                      <img
                        class="app__stepper__image-checked"
                        src="../../../../assets/images/check-green.svg"
                        alt="green-check"
                        />
                    }
                    {{ step.name }}
                  </li>
                }
              </ul>
            }
          </nav>
        
      </div>
    </ng-container>
    <div class="w-full h-full px-6 pt-8 relative mx-auto bg-[#FAFAFA] overflow-y-auto" [ngClass]="{'overflow-register-templateclass': switchFromUser}">
      <section class="w-[660px] mx-auto relative">
      
          <div class="flex flex-col">
            <p class="flex">
              <span
                [class]="vault_step_1 ? 'block w-[70px] h-[0.3rem] rounded-lg bg-k-blue mr-2' : 'w-[70px] h-[0.3rem] rounded-lg bg-[#7E9BD4] mr-2'"
                >
              </span>
              <span
                [class]="vault_step_2 ? 'block w-[70px] h-[0.3rem]  rounded-lg  bg-k-blue  mr-2' : 'w-[70px] h-[0.3rem] rounded-lg bg-[#DCDCD] mr-2'"
                >
              </span>
            </p>
           
              <p class="m-0 font-open-sans text-[20px] not-italic font-bold leading-[30px] text-black">
                Select a vault for this {{templatetype}}
              </p>
            
          </div>
       
          <section>
            <add-vault
              [fromTemplateRegister]="true"
              (detailsVaultEmitter)="openVaultTemplate($event)"
              (dVaultEmitter)="addVAultDone($event)"
            ></add-vault>
            <button class="app__centered-item bg-transparent font-bold text-xs hover:cursor-pointer mt-4" (click)="closeSideNav()">
              <span class="app__centered-item gap-2 text-[#18191C]"
                ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
                >
              </button>
            </section>
          
        </section>
      </div>
    </section>
  <!-- </mat-sidenav>
</mat-sidenav-container> -->

